<template>
  <vs-col class="reset-alert-height" v-if="Boolean(selected)">
    <vs-alert :active="Boolean(selected)" title="OFERTA SELECIONADA" color="dark">
        <p>{{ selected.FILIALCAMPUS }} ({{ selected.CIDADE }}) - {{ modalidade }}</p>
        <p v-if="discipline"><strong>Início da Turma:</strong> {{discipline}}</p>
        <p v-if="electives"><strong>Eletiva(s)/Optativa(s) selecionada(s): </strong>
        <span v-for="(elective, electiveIndex) in electives" :key="electiveIndex">
          {{elective.DISCIPLINA}}
        </span></p>
        <p v-if="introductory"><strong>Introdutória Selecionada: </strong> {{formatTitle(introductory)}}</p>
    </vs-alert>
  </vs-col>
</template>

<script>
import { formatDateToLocale } from '../helpers'
import { getStepsInformation } from '../helpers/storage'

export default {
  name: 'SelectedOfferBox',
  data: () => ({
    selected: null,
    discipline: null,
    electives: null,
    introductory: null,
    taxPayment: null
  }),
  created() {
    const stepsData = getStepsInformation()
    if (stepsData.offer) this.selected = stepsData.offer
    if (stepsData.classData) this.discipline = formatDateToLocale(stepsData.classData.DTINICIAL)
    if (stepsData.electives) this.electives = stepsData.electives
    if (stepsData.introductory) this.introductory = stepsData.introductory
    if (stepsData.taxPayment) this.payment = stepsData.taxPayment
  },
  computed: {
    modalidade() {
      if (this.selected.MODALIDADE === "D") return "À DISTÂNCIA"
      return `${this.selected.TURNO}`
    }
  },
  methods:{
    formatTitle(introductory){
      let datas =  formatDateToLocale(introductory.DTINICIAL);
      const {offer} = getStepsInformation();
      if(introductory.DTINICIAL != introductory.DTFINAL)
        datas= `${formatDateToLocale(introductory.DTINICIAL)} a ${formatDateToLocale(introductory.DTFINAL)}`

      if(offer.MODALIDADE!='D'){
        datas = datas + ` - ${introductory.TURNO} - ${introductory.HORARIO}`
      }
      return datas
    }
  }
}
</script>


<style>
.reset-alert-height > div {
  height: initial !important;
}
</style>
